import { Objective } from '@/features/actions/logic/types'
import { EModeCategoryId } from '@/features/sparklend/common/data/market-info/emode'

export function createEModeObjectives(
  userEModeCategoryId: EModeCategoryId,
  selectedEModeCategoryId: EModeCategoryId,
): Objective[] | undefined {
  if (userEModeCategoryId === selectedEModeCategoryId) {
    return undefined
  }
  return [
    {
      type: 'setUserEMode',
      eModeCategoryId: selectedEModeCategoryId,
    },
  ]
}
